import styled from "styled-components";

export const Wrapper = styled.div`
    top: 0 !important;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    border: ${props => (props.disabled ? "unset" : "1px solid #999d9a")};

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${props => (props.disabled ? "not-allowed" : !props?.hover ? "default" : "pointer")};

    font-weight: bold;
    transition: background-color 0.3s;
    transition: border 1s;
    &:hover {
        transition: border 0.1s;
        background-color: ${props => (props.disabled ? "initial" : "#a7dbde")};
        border: ${props =>
            props.disabled ? "unset" : !props?.hover ? "1px solid #999d9a" : "2px solid black"};
    }
`;

export const SlotContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 2;
`;
